import { useEffect, useRef, useState } from 'react';

interface BeanCounterProps {
  value: number;
  className?: string;
  duration?: number;
}

export function BeanCounter({ value, className = '', duration = 300 }: BeanCounterProps) {
  const [display, setDisplay] = useState(value);
  const prevValue = useRef(value);
  const animRef = useRef<number | null>(null);

  useEffect(() => {
    const from = prevValue.current;
    const to = value;
    if (from === to) return;

    const startTime = performance.now();
    const animate = (now: number) => {
      const t = Math.min(1, (now - startTime) / duration);
      // Ease-out
      const eased = 1 - Math.pow(1 - t, 3);
      const current = Math.round(from + (to - from) * eased);
      setDisplay(current);
      if (t < 1) {
        animRef.current = requestAnimationFrame(animate);
      } else {
        prevValue.current = to;
      }
    };
    animRef.current = requestAnimationFrame(animate);

    return () => {
      if (animRef.current) cancelAnimationFrame(animRef.current);
    };
  }, [value, duration]);

  return (
    <span className={`tabular-nums ${className}`}>
      {display.toLocaleString('vi-VN')}
    </span>
  );
}
